module.exports = __webpack_public_path__ + "static/media/detalhes.bb8cb254.svg";